import { render, staticRenderFns } from "./CalendarHome.vue?vue&type=template&id=653d03f5&scoped=true"
import script from "./CalendarHome.vue?vue&type=script&lang=js"
export * from "./CalendarHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653d03f5",
  null
  
)

export default component.exports